// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f7ZHU","col":"styles_col__1A3v2"};